import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import { GiCheckMark } from "react-icons/gi";
import WhomImage1 from '../../img/w_image_1.jpg';
import WhomImage2 from '../../img/w_image_2.jpg';
import WhomImage3 from '../../img/w_image_3.jpg';
import WhomImage4 from '../../img/w_image_4.jpg';
import WhomImage5 from '../../img/w_image_5.jpg';

function FromWhom() {


    let fromArraay = [
        {
            image: WhomImage3,
            title: 'Студентка',
            description: 'знайдеш свою першу кар’єру в сфері, що швидко зростає'
        },
        {
            image: WhomImage4,
            title: 'Мама в декреті',
            description: 'повернешся до роботи у зручному, гнучкому форматі'
        },
        {
            image: WhomImage5,
            title: 'Підприємиця',
            description: 'переведеш бізнес в онлайн і залучиш нових клієнтів'
        },
        {
            image: WhomImage1,
            title: 'ВПО чи жінка за кордоном',
            description: 'здобудеш навички, які дають можливість працювати з будь-якої точки світу'
        },
        {
            image: WhomImage2,
            title: 'Активна жінка з бізнес-ідеєю',
            description: 'отримаєш впевненість, ресурси і підтримку, щоб реалізувати себе у цифровому світі'
        }
    ]

    return (
        <section className="relative py-20" id="ebaut">
            <div className="container w-[90%] max-w-screen-lg mx-auto">
                <div className="mb-10 w-full max-w-screen-md">
                    {/*<ScrollAnimation animateIn="animate__fadeInUp"><h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl">Про івент</h6></ScrollAnimation>*/}
                    <ScrollAnimation animateIn="animate__fadeInUp">
                        <h2
                        className="sm:text-4xl text-2xl mb-4 uppercase title-design before:bg-[#8C98FF]/40 after:bg-[#8C98FF]/40"><span>Для кого ця програма?</span></h2>
                    </ScrollAnimation>
                    <ScrollAnimation animateIn="animate__fadeInUp">
                        <div>
                            <p>Women in Tech створена для жінок, які хочуть змінити своє життя через цифрові можливості — незалежно від стартової точки. Вона відкриває доступ до знань, інструментів і підтримки, необхідних для впевненого кроку в майбутнє.</p>
                        </div>
                    </ScrollAnimation>
                </div>
            </div>
            <div className="container w-[90%] max-w-screen-xl mx-auto">
                <div
                    className="md:flex flex-wrap relative z-20">


                    <div className="grid lg:grid-cols-5 grid-cols-2 gap-x-3 gap-y-6">
                        {
                            fromArraay ? fromArraay.map((item, index) => (
                                <div>
                                    <div className="relative overflow-hidden pl-3 pb-3 mb-2">
                                        <img src={item.image} alt={item.title} className="relative z-20"/>
                                        <div
                                            className="absolute bottom-0 -left-1/4 w-1/2 h-full bg-[#8C98FF]/80 transform-gpu skew-x-[30deg] z-20"/>
                                        <div
                                            className="absolute top-0 -right-1/2 w-3/5 h-1/4 bg-white transform-gpu skew-x-[45deg] z-20"/>
                                        <div
                                            className="absolute bottom-0 left-0 w-full h-full bg-[#8C98FF]/80 transform-gpu skew-x-[30deg] z-10" />
                                    </div>
                                    <ScrollAnimation animateIn="animate__fadeInUp">
                                    <h3 className="text-1xl mb-2">{item.title}</h3>
                                    <div className="flex flex-wrap max-sm:text-[13px] text-base/tight"><GiCheckMark className="text-[#8C98FF] w-[20px] mr-[5px]" /> <div className="w-[calc(100%-45px)]">{item.description}</div></div>
                                    </ScrollAnimation>
                                </div>
                            )) : ''
                        }
                    </div>

                </div>

            </div>
        </section>
    )
}

export default FromWhom